import { Controller } from "@hotwired/stimulus";

// Desktop ↔ mobile toggle for live-preview iframes (page builders +
// funnel overview). The wrap/frame elements each carry their own FULL
// class string per device (data-desktop-class / data-mobile-class) and
// the controller just swaps them — so one controller serves layouts as
// different as the builder's flex pane and the overview's scaled card.
// Swapping classes never reloads the iframe.
export default class extends Controller {
  static targets = ["wrap", "frame", "button"];

  ACTIVE = ["bg-gray-200", "dark:bg-gray-600", "text-gray-900", "dark:text-white"];

  choose(event) {
    const device = event.params.device === "mobile" ? "mobile" : "desktop";
    [this.hasWrapTarget && this.wrapTarget, this.hasFrameTarget && this.frameTarget]
      .filter(Boolean)
      .forEach((el) => {
        const classes = device === "mobile" ? el.dataset.mobileClass : el.dataset.desktopClass;
        if (classes) el.className = classes;
      });
    this.buttonTargets.forEach((btn) => {
      const active = btn.dataset.device === device;
      this.ACTIVE.forEach((cls) => btn.classList.toggle(cls, active));
    });
  }
}
